import { KEY_VALUES_SERVICE } from "@/services/keyValues.service.js";

const state = { 
    tiktokVideosOutput: [], 
    processTask: false 
};

const actions = {
    getTikTokVideos({ dispatch, commit }, language = null) {
        dispatch('alert/clear', null, { root: true });
        commit('tiktokVideosRequest');
        
        KEY_VALUES_SERVICE.getTikTokVideos(language)
            .then(
                response => {
                    commit('tiktokVideosSuccess', response);
                },
                error => {
                    commit('tiktokVideosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    tiktokVideosRequest(state) {
        state.processTask = null;
    },
    tiktokVideosSuccess(state, response) {
        // Extract video URLs from the API response based on language
        const videos = [];
        const language = response.language;
        
        if (response && response.data && Array.isArray(response.data)) {
            // Sort by key to ensure consistent order (tiktok1, tiktok2, tiktok3, tiktok4)
            const sortedData = response.data.sort((a, b) => a.key.localeCompare(b.key));
            
            sortedData.forEach(item => {
                if (item.key.startsWith('tiktok') && item.values && item.values[language]) {
                    videos.push(item.values[language]);
                }
            });
        }
        state.tiktokVideosOutput = videos;
        state.processTask = true;
    },
    tiktokVideosFailure(state) {
        state.tiktokVideosOutput = [];
        state.processTask = false;
    }
};

export const keyValues = {
    namespaced: true,
    state,
    actions,
    mutations
};
